export default {
  data: () => ({}),
  methods: {
    getPrettyShipping(shipping) {
      if (shipping == 'instore_pickup') {
        return 'pickup';
      } else if (shipping == 'flatrate_flatrate') {
        return 'domicilio';
      }

      return null;
    },
    getPrettyInconsistency(status) {
      switch (status) {
        case 'Alredy_Completed':
          return 'La orden ya fué completada.';
        case 'Complete_Lista':
          return 'No completada correctamente, intenta de nuevo.';
        case 'Incorrect_Subsidiary':
          return 'La orden no pertenece a esta sucursal.';
        case 'Not_Created_When_Order_Placed':
          return 'Orden no creada correctamente.';
        case 'Created_In_Incorrect_Subsidiary':
          return 'La orden no pertenece a esta sucursal.';
        case 'Order_Closed':
          return 'Orden cerrada, por favor verifica.';
        case 'Order_Canceled':
          return 'Orden cancelada, por favor verifica.';
        case 'Order_Holded':
          return 'Orden retenida, por favor verifica.';
        case 'Order_Suspect_Fraud':
          return 'Sospecha de fraude, por favor verifica.';
        case 'Error':
          return 'Sospecha de fraude, por favor verifica.';
        default: return 'Error Desconocido.';
      }
    },
    moveOrder(order) {
      if (this.$store.state.realtimeOrdersStatus[order.entity_id] !== undefined) {
        const status = this.$store.state.realtimeOrdersStatus[order.entity_id].Status;

        const statusIndex = this.$store.state.status.indexOf(status);
        const nextStatus = this.$store.state.status[statusIndex + 1]

        this.confirm(order.entity_id.toString(), nextStatus);
      }
    },
    confirm(orderId, nextStatus) {
      if (nextStatus.length > 0) {
        this.$swal
          .fire({
            title: `¿Cambiar a ${nextStatus}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, cambiar',
            cancelButtonText: 'Cancelar'
          })
          .then((result) => {
            if (result.value) {
              this.changeStatus(orderId, nextStatus);
            }
          });
      }
    },
    changeStatus(orderId, nextStatus) {
      this.$swal.fire({
        title: 'Cambiar Estatus',
        html: 'Espera...',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading();
          
          this.changeStatusCall(orderId, nextStatus)
            .then((result) => {
              if (result.result == 'OK') {
                this.$swal.close();
                this.$swal.fire({
                  title: 'Correcto!',
                  text: 'Tu orden fué actualizada.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2000
                });
              } else {
                this.$swal.close();
                this.$swal.fire({
                  title: 'Error',
                  text: 'Ocurrió un error al actualizar tu orden.',
                  icon: 'error',
                  showConfirmButton: false,
                  timer: 2000
                });
              }
            })
            .catch(() => {
              this.$swal.close();
              this.$swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al actualizar tu orden.',
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
              });
            });
        }
      })
    },
    async changeStatusCall(orderId, nextStatus) {
      const session = this.$store.state.session;

      return await this.$magentoAxios.post('advanceStatus', {
        status: nextStatus,
        store: session.storeId,
        order: orderId,
        sucursal: session.storePickUpCode
      });
    },
    async sendTokenCall(action, token) {
      return await this.$magentoAxios.post(`SubusidiaryNotification/${action}`, {
        FCMToken: token
      });
    },
  }
};